<template>
  <div class="Dashbord" ref="document">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <v-tabs fixed-tabs v-model="selectedTab">
      <v-tab
        v-on:click.native="promeniTab"
        style="padding-left: 20px; padding-right: 20px"
        >Dnevnik flaširanja</v-tab
      >
      <v-tab
        v-on:click.native="promeniTab"
        style="padding-left: 20px; padding-right: 20px"
        >Utrošak materijala</v-tab
      >
      <v-tab
        v-on:click.native="promeniTab"
        style="padding-left: 20px; padding-right: 20px"
        >ZAVRŠNA DORADA</v-tab
      >
    </v-tabs>
    <div class="Actions__Content" style="padding: 10px">
      <div class="DataTable">
        <div fluid style="padding-top: 10px; padding-bottom: 10px">
          <v-layout
            row
            wrap
            style="padding-top: 0px !important; max-height: 1000px !important"
          >
            <v-flex
              xs2
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-menu
                ref="menuOd"
                v-model="menuOd"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateFormattedOd"
                  label="Datum od"
                  readonly
                  @blur="dateOd = parseDate(dateFormattedOd)"
                ></v-text-field>
                <v-date-picker
                  v-model="dateOd"
                  no-title
                  @input="menuOd = false"
                  :max="maxDate"
                ></v-date-picker>
                <v-btn
                  text
                  color="primary"
                  @click="
                    dateOd = null;
                    $refs.menuOd.save([]);
                  "
                  >Poništi izbor
                </v-btn>
              </v-menu>
            </v-flex>
            <v-flex
              xs2
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-menu
                ref="menuDo"
                v-model="menuDo"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateFormattedDo"
                  label="Datum do"
                  readonly
                  @blur="dateDo = parseDate(dateFormattedDo)"
                ></v-text-field>
                <v-date-picker
                  v-model="dateDo"
                  no-title
                  @input="menuDo = false"
                  :max="maxDate"
                ></v-date-picker>
                <v-btn
                  text
                  color="primary"
                  @click="
                    dateDo = null;
                    $refs.menuDo.save([]);
                  "
                  >Poništi izbor
                </v-btn>
              </v-menu>
            </v-flex>
            <v-flex
              xs7
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
            </v-flex>
            <v-flex xs1 style="text-align: right">
              <v-btn
                @click="submit"
                class="AppButtonFilled"
                style="margin-top: 15px"
                >Pretraži</v-btn
              >
            </v-flex>
          </v-layout>
          <v-form ref="form">
            <v-layout
              row
              wrap
              style="padding-top: 0px !important; max-height: 1000px !important"
            >
              <v-flex
                xs4
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="wt_select"
                  :items="wt_items"
                  item-text="name"
                  item-value="id"
                  label="Tip vina"
                  persistent-hint
                  return-object
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                  v-on:change="changeRouteTipVina"
                  outlined
                  dense
                >
                </v-autocomplete>
              </v-flex>
              <v-flex
                xs2
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="year_select"
                  :items="year_items"
                  item-text="year"
                  item-value="id"
                  label="Godina"
                  persistent-hint
                  return-object
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                  outlined
                  dense
                  v-on:change="changeRouteGodina"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex
                xs5
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="wine_select"
                  :items="wine_items"
                  :item-text="getFieldTextWine"
                  item-value="id"
                  label="Vino u tanku"
                  persistent-hint
                  return-object
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                  outlined
                  dense
                >
                </v-autocomplete>
              </v-flex>
              <v-flex
                xs1
                style="
                  text-align: center;
                  margin-bottom: 0px;
                  padding-left: 30px;
                "
              >
                <!-- <download-excel
                :data="json_data"
                :fields="json_fields"
                :meta="json_meta"
                :name="naziv_fajla"
                :param="json_fields"
              >
                <img
                  src="../assets/menuIcons/ico-print.png"
                  title="Štampa dokumenta"
                />
              </download-excel> -->

                <v-btn @click="stampaj" fab small
                  ><img
                    src="../assets/menuIcons/ico-print.png"
                    title="Štampa dokumenta"
                /></v-btn>
              </v-flex>
            </v-layout>
          </v-form>
          <div>
            <p style="width: 97%; text-align: right; color: grey">
              * označava vina koja se koriste samo u proizvodnji
            </p>
          </div>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <v-flex
              xs12
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
              v-if="selectedTab === 0"
            >
              <v-data-table
                :headers="headers_states"
                :items="items_states"
                class="TankTable"
                item-key="id"
                ref="dTable"
                :pagination.sync="paginationKartica"
                style="padding-top: 10px"
                expand
                fixed-header
                hide-actions
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="padding-left: 5px; padding-right: 5px"
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKartica.descending ? 'desc' : 'asc',
                        header.value === paginationKartica.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                      @click="changeSortKartica(header.value)"
                    >
                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <tr>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        items_states
                          .map(function (x) {
                            return x.id;
                          })
                          .indexOf(props.item.id) + 1
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ formatDateTime(props.item.date) }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.tank }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.wine }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.lot }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.volume }} l
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.quantity }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.bottles !== null
                          ? props.item.bottles
                          : "-"
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.bottlesDiff !== null
                          ? props.item.bottlesDiff
                          : "-"
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.description !== null
                          ? props.item.description
                          : "-" }}
                    </td>
                    <!-- <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ "-" }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ "-" }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ "-" }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ "-" }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    ></td> -->
                  </tr>
                </template>
                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
              </v-data-table>
            </v-flex>
            <v-flex
              xs12
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
              v-else-if="selectedTab === 2"
            >
              <v-data-table
                :headers="headers_states"
                :items="items_states"
                class="TankTable"
                item-key="id"
                ref="dTable"
                :pagination.sync="paginationKartica"
                style="padding-top: 10px"
                expand
                fixed-header
                hide-actions
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="padding-left: 5px; padding-right: 5px"
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKartica.descending ? 'desc' : 'asc',
                        header.value === paginationKartica.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                      @click="changeSortKartica(header.value)"
                    >
                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <tr>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        items_states
                          .map(function (x) {
                            return x.id;
                          })
                          .indexOf(props.item.id) + 1
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ formatDateTime(props.item.date) }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.tank }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.wine }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.lot }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.volume }} l
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.quantity }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.ph !== null ? props.item.ph : "-" }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.freeSo2 !== null ? props.item.freeSo2 : "-"
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.totalSo2 !== null ? props.item.totalSo2 : "-"
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.sugar !== null ? props.item.sugar : "-" }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.tatalAcid !== null
                          ? props.item.tatalAcid
                          : "-"
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.conductivity !== null
                          ? props.item.conductivity
                          : "-"
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.proteinStability !== null
                          ? props.item.proteinStability
                          : "-"
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.alcohol !== null ? props.item.alcohol : "-"
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    ></td>
                  </tr>
                </template>
                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
              </v-data-table>
            </v-flex>
            <v-flex
              xs12
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
              v-else-if="selectedTab === 1"
            >
              <v-data-table
                :headers="headers_states"
                :items="items_states"
                class="TankTable"
                item-key="id"
                ref="dTable"
                :pagination.sync="paginationKartica"
                style="padding-top: 10px"
                expand
                fixed-header
                hide-actions
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="padding-left: 5px; padding-right: 5px"
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKartica.descending ? 'desc' : 'asc',
                        header.value === paginationKartica.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                      @click="changeSortKartica(header.value)"
                    >
                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <tr>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      @click="ekspandujRed(props)"
                    >
                      {{
                        items_states
                          .map(function (x) {
                            return x.id;
                          })
                          .indexOf(props.item.id) + 1
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ formatDateTime(props.item.date) }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      @click="ekspandujRed(props)"
                    >
                      {{ props.item.tank }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      @click="ekspandujRed(props)"
                    >
                      {{ props.item.wine }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      @click="ekspandujRed(props)"
                    >
                      {{ props.item.lot }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      @click="ekspandujRed(props)"
                    >
                      {{ props.item.volume }} l
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      @click="ekspandujRed(props)"
                    >
                      {{ props.item.quantity }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      @click="ekspandujRed(props)"
                    >
                      {{
                        props.item.bottles !== null ? props.item.bottles : "-"
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      @click="ekspandujRed(props)"
                    >
                      {{
                        props.item.outage !== null
                          ? props.item.outage
                          : "-"
                      }}
                    </td>
                  </tr>
                </template>

                <template slot="expand" slot-scope="props">
                  <template>
                    <table class="topics" style="background: #f3f7f4">
                      <tr
                        style="
                          border-bottom: solid;
                          border-width: 1px;
                          border-color: grey;
                        "
                      >
                        <th>Grupa repromaterijala</th>
                        <th
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          Repromaterijal
                        </th>
                        <th
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          Utrošeno
                        </th>
                        <th
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          Potrebno
                        </th>
                        <th
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                        Razlika
                        </th>
                      </tr>
                      <tr
                        v-for="(item, index) in props.item.usedMaterials"
                        :key="index"
                      >
                        <td style="width: 20%">{{ item.groupName }}</td>
                        <td
                          style="
                            width: 25%;
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ item.material }}
                        </td>
                        <td
                          style="
                            width: 20%;
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{
                            item.usedMaterialQuantity !== null
                              ? item.usedMaterialQuantity
                              : "-"
                          }}
                        </td>
                        <td
                          style="
                            width: 20%;
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{
                            item.neededMaterialQuantity !== null
                              ? item.neededMaterialQuantity
                              : "-"
                          }}
                        </td>
                        <td
                          style="
                            width: 15%;
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{
                            item.usedMaterialQuantity - item.neededMaterialQuantity !== 0
                              ? item.usedMaterialQuantity - item.neededMaterialQuantity
                              : "-"
                          }}
                        </td>
                      </tr>
                    </table>
                  </template>
                </template>

                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>

        <script>
import { serverBus } from "../main";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TokenComponent from "../components/Token";

import html2pdf from "html2pdf.js";

import { readJSON, getDateTime } from "../helpers/Functions";
//import { valueToRelative } from "@amcharts/amcharts4/.internal/core/utils/Utils";

export default {
  props: ["operationType"],
  name: "Maka",
  dialog: false,
  components: {
    TokenComponent,
    Loading,
  },
  data() {
    return {
      json_fields: {},
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      isLoading: false,
      fullPage: true,
      headers_states: [
        { text: "Rb." },
        { text: "Datum punjenja", value: "date", align: "center", sortable: true },
        { text: "Oznaka suda", value: "tank", align: "center", sortable: true },
        {
          text: "Naziv proizvoda",
          value: "wine",
          align: "center",
          sortable: true,
        },
        {
          text: "Zapremina",
          value: "volume",
          align: "center",
          sortable: true,
        },
        {
          text: "Količina",
          value: "quantity",
          align: "center",
          sortable: true,
        },
        {
          text: "pH vrednost",
          value: "ph",
          align: "center",
          sortable: true,
        },
        {
          text: "Slobodni SO2",
          value: "freeSo2",
          align: "center",
          sortable: true,
        },
        {
          text: "Ukupni SO2",
          value: "totalSo2",
          align: "center",
          sortable: true,
        },
        {
          text: "Redukujući šećer",
          value: "sugar",
          align: "center",
          sortable: true,
        },
        {
          text: "Ukupne kiseline",
          value: "tatalAcid",
          align: "center",
          sortable: true,
        },
        {
          text: "Konduktivitet",
          value: "conductivity",
          align: "right",
          sortable: true,
        },
        {
          text: "Proteinska stabilnost",
          value: "proteinStability",
          align: "right",
          sortable: true,
        },
        {
          text: "Alkohol",
          value: "alcohol",
          align: "right",
          sortable: true,
        },
        {
          text: "Verifikovao",
          align: "right",
          sortable: false,
        },
      ],
      items_states: [],
      paginationKartica: {
        sortBy: "id",
        descending: false,
        rowsPerPage: 1000000,
        current: 1,
        page: 1,
      },
      redovaPoStrani: 25,
      search: "",
      izabranaStranica: 0,

      operation_to_select: undefined,

      loading: true,
      naziv_fajla: "",
      naslov: "",

      filterEtiketa: "",
      fiterTipoviVina: "",
      fiterGodine: "",

      json_fields_type: [],

      datumOdFiter: "",
      datumDoFiter: "",

      menuOd: "",
      dateOd: null,
      dateFormattedOd: null,
      menuDo: "",
      dateDo: null,
      dateFormattedDo: null,

      wine_items: [],
      wine_select: undefined,
      year_items: [],
      year_select: undefined,
      wt_items: [],
      wt_select: undefined,
      selectedTab: 0,
    };
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  watch: {
    operationType: function (val) {
      this.clear();

      if (val !== null && val !== undefined) {
        this.selectedTab = 2;

        if (this.wt_items.length === 0) {
          this.getAllWineTypes();
        }

        this.selectedTab = 0;
        this.getAllPracenjeEvidencije();
      }
    },
    dateOd(val) {
      this.dateFormattedOd = this.formatDate1(this.dateOd);
    },
    dateDo(val) {
      this.dateFormattedDo = this.formatDate1(this.dateDo);
    },
    params: {
      deep: true,
    },
  },

  methods: {
    promeniTab() {
      this.paginationKartica.sortBy = "id";
      this.getAllVinaSifarnik();

      if (this.selectedTab === 0) this.getAllPracenjeEvidencije();
      else if (this.selectedTab === 2) this.getAllVina();
      else this.getAllUtrosakMaterijala();
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      var date7 = new Date();
      date7.setDate(today.getDate() - 7);

      let Year7 = `${date7.getFullYear()}`;
      let Month7 = `${date7.getMonth() + 1}`;
      let Day7 = `${date7.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      if (Month7.length < 2) Month7 = `0${Month7}`;
      if (Day7.length < 2) Day7 = `0${Day7}`;

      this.dateOd = [Year7, Month7, Day7].join("-");
      this.dateDo = [Year, Month, Day].join("-");
    },
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${day}.${month}.${year}`;
    },
    formatDateTime(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    ekspandujRed(item) {
      item.expanded = !item.expanded;
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.selectedTab === 0) this.getAllPracenjeEvidencije();
        else if (this.selectedTab === 2) this.getAllVina();
        else this.getAllUtrosakMaterijala();
      }
    },
    changeRouteTipVina(a) {
      if (this.year_select !== undefined) this.year_select = undefined;
      else this.getAllVinaSifarnik(a);

      this.getAllYearsSifarnik(a);
    },
    changeRouteGodina(a) {
      if (this.wine_select !== undefined) this.wine_select = undefined;

      this.getAllVinaSifarnik(this.wt_select, a);
    },
    getAllWineTypes() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine_type/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // // console.log(response.data);

          this.wt_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine_type/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.wt_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllYearsSifarnik(a) {
      let pom_operation_to_to_select = "";

      if (a !== undefined)
        a.forEach(function (entry) {
          pom_operation_to_to_select =
            pom_operation_to_to_select + "wineTypeId=" + entry.id + "&";
        });

      let url = "/wine/years_all";
      if (pom_operation_to_to_select !== "")
        url =
          url +
          "?" +
          pom_operation_to_to_select.substring(
            0,
            pom_operation_to_to_select.length - 1
          );

      this.$http
        .get(this.globalServiceLocation + this.globalPort + url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // // console.log(response.data);

          this.year_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(this.globalServiceLocation + this.globalPort + url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      // // console.log(response.data);

                      this.year_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllVinaSifarnik(a) {
      let pom_operation_to_to_select = "";

      if (a !== undefined)
        a.forEach(function (entry) {
          pom_operation_to_to_select =
            pom_operation_to_to_select + "wineTypeId=" + entry.id + "&";
        });

      let url = "/wine/all";
      if (pom_operation_to_to_select !== "")
        url =
          url +
          "?" +
          pom_operation_to_to_select.substring(
            0,
            pom_operation_to_to_select.length - 1
          );

      this.$http
        .get(this.globalServiceLocation + this.globalPort + url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          //// // console.log(response.data);

          this.wine_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(this.globalServiceLocation + this.globalPort + url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      //// // console.log(response.data);

                      this.wine_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getFieldTextWine(item) {
      let response = "";
      if (item.length === undefined)
        if (item.wineLabel !== undefined)
          response = `${item.wineLabel.name} ${item.year} ${
            item.wineLabel.inProduction ? "*" : ""
          }`;

      return response;
    },

    getAllVina() {
      this.isLoading = true;

      this.headers_states = [
        { text: "Rb." },
        { text: "Datum punjenja", value: "date", align: "center", sortable: true },
        { text: "Oznaka suda", value: "tank", align: "center", sortable: true },
        {
          text: "Naziv proizvoda",
          value: "wine",
          align: "center",
          sortable: true,
        },
        { text: "Lot", value: "tank", align: "center", sortable: true },
        {
          text: "Zapremina",
          value: "volume",
          align: "center",
          sortable: true,
        },
        {
          text: "Količina",
          value: "quantity",
          align: "center",
          sortable: true,
        },
        {
          text: "pH vrednost",
          value: "ph",
          align: "center",
          sortable: true,
        },
        {
          text: "Slobodni SO2",
          value: "freeSo2",
          align: "center",
          sortable: true,
        },
        {
          text: "Ukupni SO2",
          value: "totalSo2",
          align: "center",
          sortable: true,
        },
        {
          text: "Redukujući šećer",
          value: "sugar",
          align: "center",
          sortable: true,
        },
        {
          text: "Ukupne kiseline",
          value: "tatalAcid",
          align: "center",
          sortable: true,
        },
        {
          text: "Konduktivitet",
          value: "conductivity",
          align: "right",
          sortable: true,
        },
        {
          text: "Proteinska stabilnost",
          value: "proteinStability",
          align: "right",
          sortable: true,
        },
        {
          text: "Alkohol",
          value: "alcohol",
          align: "right",
          sortable: true,
        },
        {
          text: "Verifikovao",
          align: "right",
          sortable: false,
        },
      ];

      this.naziv_fajla = "vino_u_tankovima.xls";
      this.naslov = "Završna dorada";

      this.json_fields = {
        Rb: "String",
        "Datum punjenja": "Date",
        "Oznaka suda": "String",
        "Naziv proizvoda": "String",
        Lot: "String",
        Zapremina: "String",
        Količina: "String",
        "pH vrednost": "String",
        "Slobodni SO2": "String",
        "Ukupni SO2": "String",
        "Redukujući šećer": "String",
        "Ukupne kiseline": "String",
        Konduktivitet: "String",
        "Proteinska stabilnost": "String",
        Alkohol: "String",
        Verifikovao: "String",
      };

      this.json_fields_type = [
        "String",
        "Date",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
      ];

      let _this = this;

      let strDate = "";
      if (this.dateOd !== null) {
        strDate = "&from=" + this.dateOd + "T00:00";
        this.datumOdFiter = this.dateOd;
      }

      let strDateDo = "";
      if (this.dateDo !== null) {
        strDateDo = "&to=" + this.dateDo + "T23:59";
        this.datumDoFiter = this.dateDo;
      }

      var pom_operation_to_to_select = "";

      this.fiterTipoviVina = "";

      if (this.wt_select !== undefined && this.wt_select !== null) {
        this.wt_select.forEach(function (entry) {
          pom_operation_to_to_select =
            pom_operation_to_to_select + "wineTypeId=" + entry.id + "&";

          _this.fiterTipoviVina = _this.fiterTipoviVina + entry.name + ", ";
        });
      }

      var pom_godine = "";

      this.fiterGodine = "";

      if (this.year_select !== undefined && this.year_select !== null) {
        this.year_select.forEach(function (entry) {
          pom_godine = pom_godine + "year=" + entry + "&";

          _this.fiterGodine = _this.fiterGodine + entry + ", ";
        });
      }

      var pom_etiketa = "";
      this.filterEtiketa = "";

      if (this.wine_select !== undefined && this.wine_select !== null) {
        this.wine_select.forEach(function (entry) {
          pom_etiketa = pom_etiketa + "wineId=" + entry.id + "&";

          _this.filterEtiketa =
            _this.filterEtiketa +
            entry.wineLabel.name +
            " " +
            entry.year +
            (entry.wineLabel.inProduction ? " *" : "") +
            ", ";
        });
      }

      let sortiranje = "";
      if (this.paginationKartica.sortBy !== "") {
        let orderovanje = "";
        if (this.paginationKartica.descending) orderovanje = "desc";
        else orderovanje = "asc";

        sortiranje =
          "sort=" +
          this.paginationKartica.sortBy.replace("documentNumber", "number") +
          "&order=" +
          orderovanje;
      }

      let urlLoc =
        "/operation/measures_before_bottling?" +
        pom_etiketa +
        pom_operation_to_to_select +
        pom_godine;

      if (
        urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "?" ||
        urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "&"
      )
        urlLoc = urlLoc + sortiranje;
      else urlLoc = urlLoc + "&" + sortiranje;

      // urlLoc = urlLoc.substring(0, urlLoc.length - 1);

      let urlFinish;

      urlFinish = urlLoc + strDate + strDateDo;

      setTimeout(() => {
        this.$http
          .get(this.globalServiceLocation + this.globalPort + urlFinish, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            this.items_states = response.data;

            let _this = this;
            this.json_data = [];
            let rbr = 1;

            response.data.forEach(function (entry) {
              let objekat = {
                Rb: rbr,
                "Datum punjenja": _this.formatDateTime(entry.date),
                "Oznaka suda": entry.tank,
                "Naziv proizvoda": entry.wine,
                Lot: entry.lot,
                Zapremina: entry.volume + " l",
                Količina: entry.quantity,
                "pH vrednost": entry.ph !== null ? entry.ph : "-",
                "Slobodni SO2": entry.freeSo2 !== null ? entry.freeSo2 : "-",
                "Ukupni SO2": entry.totalSo2 !== null ? entry.totalSo2 : "-",
                "Redukujući šećer": entry.sugar !== null ? entry.sugar : "-",
                "Ukupne kiseline":
                  entry.tatalAcid !== null ? entry.tatalAcid : "-",
                Konduktivitet:
                  entry.conductivity !== null ? entry.conductivity : "-",
                "Proteinska stabilnost":
                  entry.proteinStability !== null
                    ? entry.proteinStability
                    : "-",
                Alkohol: entry.alcohol !== null ? entry.alcohol : "-",
                Verifikovao: " ",
              };
              _this.json_data.push(objekat);

              rbr = rbr + 1;
            });
            this.isLoading = false;
          })
          .catch((e) => {
            if (!e.response) {
              this.isLoading = false;
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          urlFinish,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.items_states = response.data;

                        let _this = this;
                        this.json_data = [];
                        let rbr = 1;

                        response.data.forEach(function (entry) {
                          let objekat = {
                            Rb: rbr,
                            "Datum punjenja": _this.formatDateTime(entry.date),
                            "Oznaka suda": entry.tank,
                            "Naziv proizvoda": entry.wine,
                            Lot: entry.lot,
                            Zapremina: entry.volume + " l",
                            Količina: entry.quantity,
                            "pH vrednost": entry.ph !== null ? entry.ph : "-",
                            "Slobodni SO2":
                              entry.freeSo2 !== null ? entry.freeSo2 : "-",
                            "Ukupni SO2":
                              entry.totalSo2 !== null ? entry.totalSo2 : "-",
                            "Redukujući šećer":
                              entry.sugar !== null ? entry.sugar : "-",
                            "Ukupne kiseline":
                              entry.tatalAcid !== null ? entry.tatalAcid : "-",
                            Konduktivitet:
                              entry.conductivity !== null
                                ? entry.conductivity
                                : "-",
                            "Proteinska stabilnost":
                              entry.proteinStability !== null
                                ? entry.proteinStability
                                : "-",
                            Alkohol:
                              entry.alcohol !== null ? entry.alcohol : "-",
                            Verifikovao: " ",
                          };
                          _this.json_data.push(objekat);

                          rbr = rbr + 1;
                        });
                        this.isLoading = false;
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }, 10);
    },
    getAllPracenjeEvidencije() {
      this.isLoading = true;

      console.log(this.selectedTab);

      this.headers_states = [
        { text: "Rb." },
        {
          text: "Datum punjenja",
          value: "date",
          align: "center",
          sortable: true,
        },
        { text: "Oznaka suda", value: "tank", align: "center", sortable: true },
        {
          text: "Naziv proizvoda",
          value: "wine",
          align: "center",
          sortable: true,
        },
        { text: "Lot", value: "lot", align: "center", sortable: true },
        {
          text: "Zapremina",
          value: "volume",
          align: "center",
          sortable: true,
        },
        {
          text: "Količina",
          value: "quantity",
          align: "center",
          sortable: true,
        },
        {
          text: "Boca",
          value: "date",
          align: "center",
          sortable: true,
        },
        {
          text: "Broj polomljenih boca",
          value: "bottlesDiff",
          align: "center",
          sortable: true,
        },
        {
          text: "Opis",
          value: "description",
          align: "center",
          sortable: true,
        },
        // {
        //   text: "Kontrolisao",
        //   value: "",
        //   align: "center",
        //   sortable: false,
        // },
        // {
        //   text: "Dorađena količina",
        //   value: "",
        //   align: "center",
        //   sortable: false,
        // },
        // {
        //   text: "Datum",
        //   value: "",
        //   align: "center",
        //   sortable: false,
        // },
        // {
        //   text: "Radnik na liniji za flaširanje",
        //   value: "",
        //   align: "center",
        //   sortable: false,
        // },
        // {
        //   text: "Verifikovao",
        //   align: "right",
        //   sortable: false,
        // },
      ];

      this.naziv_fajla = "vino_u_tankovima.xls";
      this.naslov = "Dnevnik flaširanja";

      this.json_fields = {
        Rb: "String",
        "Datum punjenja": "Date",
        "Oznaka suda": "String",
        "Naziv proizvoda": "String",
        Lot: "String",
        Zapremina: "String",
        Količina: "String",
        "Boca": "String",
        "Broj polomljenih boca": "String",
        "Opis": "String",
        // Kontrolisao: "String",
        // "Dorađena količina": "String",
        // Datum: "Date",
        // "Radnik na liniji za flaširanje": "String",
        // Verifikovao: "String",
      };

      this.json_fields_type = [
        "String",
        "Date",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        // "String",
        // "Date",
        // "String",
        // "String",
      ];

      let _this = this;

      let strDate = "";
      if (this.dateOd !== null) {
        strDate = "&from=" + this.dateOd + "T00:00";
        this.datumOdFiter = this.dateOd;
      }

      let strDateDo = "";
      if (this.dateDo !== null) {
        strDateDo = "&to=" + this.dateDo + "T23:59";
        this.datumDoFiter = this.dateDo;
      }

      var pom_operation_to_to_select = "";

      this.fiterTipoviVina = "";

      if (this.wt_select !== undefined && this.wt_select !== null) {
        this.wt_select.forEach(function (entry) {
          pom_operation_to_to_select =
            pom_operation_to_to_select + "wineTypeId=" + entry.id + "&";

          _this.fiterTipoviVina = _this.fiterTipoviVina + entry.name + ", ";
        });
      }

      var pom_godine = "";

      this.fiterGodine = "";

      if (this.year_select !== undefined && this.year_select !== null) {
        this.year_select.forEach(function (entry) {
          pom_godine = pom_godine + "year=" + entry + "&";

          _this.fiterGodine = _this.fiterGodine + entry + ", ";
        });
      }

      var pom_etiketa = "";
      this.filterEtiketa = "";

      if (this.wine_select !== undefined && this.wine_select !== null) {
        this.wine_select.forEach(function (entry) {
          pom_etiketa = pom_etiketa + "wineId=" + entry.id + "&";

          _this.filterEtiketa =
            _this.filterEtiketa +
            entry.wineLabel.name +
            " " +
            entry.year +
            (entry.wineLabel.inProduction ? " *" : "") +
            ", ";
        });
      }

      let sortiranje = "";
      if (this.paginationKartica.sortBy !== "") {
        let orderovanje = "";
        if (this.paginationKartica.descending) orderovanje = "desc";
        else orderovanje = "asc";

        sortiranje =
          "sort=" +
          this.paginationKartica.sortBy.replace("documentNumber", "number") +
          "&order=" +
          orderovanje;
      }

      let urlLoc =
        "/operation/bottling_diary?" +
        pom_etiketa +
        pom_operation_to_to_select +
        pom_godine;

      if (
        urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "?" ||
        urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "&"
      )
        urlLoc = urlLoc + sortiranje;
      else urlLoc = urlLoc + "&" + sortiranje;

      // urlLoc = urlLoc.substring(0, urlLoc.length - 1);

      let urlFinish;

      urlFinish = urlLoc + strDate + strDateDo;

      setTimeout(() => {
        this.$http
          .get(this.globalServiceLocation + this.globalPort + urlFinish, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            this.items_states = response.data;

            let _this = this;
            this.json_data = [];
            let rbr = 1;

            response.data.forEach(function (entry) {
              let objekat = {
                Rb: rbr,
                "Datum punjenja": _this.formatDateTime(entry.date),
                "Oznaka suda": entry.tank,
                "Naziv proizvoda": entry.wine,
                Lot: entry.lot,
                Zapremina: entry.volume + " l",
                Količina: entry.quantity,
                "Boca":
                  entry.bottles !== null ? entry.bottles : "-",
                "Broj polomljenih boca":
                  entry.bottlesDiff !== null ? entry.bottlesDiff : "-",
                Opis: entry.description !== null ? entry.description : "-",
                // Kontrolisao: "-",
                // "Dorađena količina": "-",
                // Datum: "-",
                // "Radnik na liniji za flaširanje": "-",
                // Verifikovao: " ",
              };
              _this.json_data.push(objekat);

              rbr = rbr + 1;
            });
            this.isLoading = false;
          })
          .catch((e) => {
            if (!e.response) {
              this.isLoading = false;
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          urlFinish,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.items_states = response.data;

            let _this = this;
            this.json_data = [];
            let rbr = 1;

            response.data.forEach(function (entry) {
              let objekat = {
                Rb: rbr,
                "Datum punjenja": _this.formatDateTime(entry.date),
                "Oznaka suda": entry.tank,
                "Naziv proizvoda": entry.wine,
                Lot: entry.lot,
                Zapremina: entry.volume + " l",
                Količina: entry.quantity,
                "Boca":
                  entry.bottles !== null ? entry.bottles : "-",
                "Broj polomljenih boca":
                  entry.bottlesDiff !== null ? entry.bottlesDiff : "-",
                Opis: entry.description !== null ? entry.description : "-",
                // Kontrolisao: "-",
                // "Dorađena količina": "-",
                // Datum: "-",
                // "Radnik na liniji za flaširanje": "-",
                // Verifikovao: " ",
              };
              _this.json_data.push(objekat);

              rbr = rbr + 1;
            });
            this.isLoading = false;
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }, 10);
    },
    getAllUtrosakMaterijala() {
      this.isLoading = true;

      this.headers_states = [
        { text: "Rb." },
        { text: "Datum punjenja", value: "date", align: "center", sortable: true },
        { text: "Oznaka suda", value: "tank", align: "center", sortable: true },
        {
          text: "Naziv proizvoda",
          value: "wine",
          align: "center",
          sortable: true,
        },
        { text: "Lot", value: "lot", align: "center", sortable: true },
        {
          text: "Zapremina",
          value: "volume",
          align: "center",
          sortable: true,
        },
        {
          text: "Količina",
          value: "quantity",
          align: "center",
          sortable: true,
        },
        {
          text: "Boca",
          value: "bottles",
          align: "center",
          sortable: true,
        },
        {
          text: "Rastur",
          value: "outage",
          align: "center",
          sortable: true,
        },
      ];

      this.naziv_fajla = "vino_u_tankovima.xls";
      this.naslov = "Utrošak materijala";

      this.json_fields = {
        Rb: "String",
        "Datum punjenja": "Date",
        "Oznaka suda": "String",
        "Naziv proizvoda": "String",
        "Lot/Grupa repromaterijala": "String",
        "Zapremina/Repromaterijala": "String",
        "Količina/Utrošeno": "String",
        "Boca/Potrebno": "String",
        "Rastur/Razlika": "String",
      };

      this.json_fields_type = [
        "String",
        "Date",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
      ];

      let _this = this;

      let strDate = "";
      if (this.dateOd !== null) {
        strDate = "&from=" + this.dateOd + "T00:00";
        this.datumOdFiter = this.dateOd;
      }

      let strDateDo = "";
      if (this.dateDo !== null) {
        strDateDo = "&to=" + this.dateDo + "T23:59";
        this.datumDoFiter = this.dateDo;
      }

      var pom_operation_to_to_select = "";

      this.fiterTipoviVina = "";

      if (this.wt_select !== undefined && this.wt_select !== null) {
        this.wt_select.forEach(function (entry) {
          pom_operation_to_to_select =
            pom_operation_to_to_select + "wineTypeId=" + entry.id + "&";

          _this.fiterTipoviVina = _this.fiterTipoviVina + entry.name + ", ";
        });
      }

      var pom_godine = "";

      this.fiterGodine = "";

      if (this.year_select !== undefined && this.year_select !== null) {
        this.year_select.forEach(function (entry) {
          pom_godine = pom_godine + "year=" + entry + "&";

          _this.fiterGodine = _this.fiterGodine + entry + ", ";
        });
      }

      var pom_etiketa = "";
      this.filterEtiketa = "";

      if (this.wine_select !== undefined && this.wine_select !== null) {
        this.wine_select.forEach(function (entry) {
          pom_etiketa = pom_etiketa + "wineId=" + entry.id + "&";

          _this.filterEtiketa =
            _this.filterEtiketa +
            entry.wineLabel.name +
            " " +
            entry.year +
            (entry.wineLabel.inProduction ? " *" : "") +
            ", ";
        });
      }

      let sortiranje = "";
      if (this.paginationKartica.sortBy !== "") {
        let orderovanje = "";
        if (this.paginationKartica.descending) orderovanje = "desc";
        else orderovanje = "asc";

        sortiranje =
          "sort=" +
          this.paginationKartica.sortBy.replace("documentNumber", "number") +
          "&order=" +
          orderovanje;
      }

      let urlLoc =
        "/operation/bottling_material?" +
        pom_etiketa +
        pom_operation_to_to_select +
        pom_godine;

      if (
        urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "?" ||
        urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "&"
      )
        urlLoc = urlLoc + sortiranje;
      else urlLoc = urlLoc + "&" + sortiranje;

      // urlLoc = urlLoc.substring(0, urlLoc.length - 1);

      let urlFinish;

      urlFinish = urlLoc + strDate + strDateDo;

      setTimeout(() => {
        this.$http
          .get(this.globalServiceLocation + this.globalPort + urlFinish, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            this.items_states = response.data;

            let _this = this;
            this.json_data = [];
            let rbr = 1;

            response.data.forEach(function (entry) {
              let objekat = {
                Rb: rbr,
                "Datum punjenja": _this.formatDateTime(entry.date),
                "Oznaka suda": entry.tank,
                "Naziv proizvoda": entry.wine,
                Lot: entry.lot,
                Zapremina: entry.volume + " l",
                "Količina/Grupa repromaterijala": entry.quantity,
                "Boca/Repromaterijal":
                  entry.bottles !== null ? entry.bottles : "-",
                "Rastur/Količina": entry.outage !== null ? entry.outage : "-",
              };
              _this.json_data.push(objekat);

              entry.usedMaterials.forEach(function (e) {
                let obj = {
                  Rb: " ",
                  "Datum punjenja": " ",
                  "Oznaka suda": " ",
                  "Naziv proizvoda": " ",
                  "Lot/Grupa repromaterijala": e.groupName,
                  "Zapremina/Repromaterijal": e.material,
                  "Količina/Utrošeno": e.usedMaterialQuantity !== null
                      ? e.usedMaterialQuantity
                      : "-",
                  "Boca/Potrebno": e.neededMaterialQuantity !== null
                      ? e.neededMaterialQuantity
                      : "-",
                  "Rastur/Razlika":
                  e.usedMaterialQuantity - e.neededMaterialQuantity !== 0
                      ? e.usedMaterialQuantity - e.neededMaterialQuantity
                      : "-",
                };

                _this.json_data.push(obj);
              });

              rbr = rbr + 1;
            });
            this.isLoading = false;
          })
          .catch((e) => {
            if (!e.response) {
              this.isLoading = false;
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          urlFinish,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.items_states = response.data;

                        let _this = this;
                        this.json_data = [];
                        let rbr = 1;

                        response.data.forEach(function (entry) {
                          let obj = {
                  Rb: " ",
                  "Datum punjenja": " ",
                  "Oznaka suda": " ",
                  "Naziv proizvoda": " ",
                  "Lot/Grupa repromaterijala": e.groupName,
                  "Zapremina/Repromaterijal": e.material,
                  "Količina/Utrošeno": e.usedMaterialQuantity !== null
                      ? e.usedMaterialQuantity
                      : "-",
                  "Boca/Potrebno": e.neededMaterialQuantity !== null
                      ? e.neededMaterialQuantity
                      : "-",
                  "Rastur/Razlika":
                  e.usedMaterialQuantity - e.neededMaterialQuantity !== 0
                      ? e.usedMaterialQuantity - e.neededMaterialQuantity
                      : "-",
                };
                          _this.json_data.push(obj);

                          entry.usedMaterials.forEach(function (e) {
                            let obj = {
                              Rb: " ",
                              "Oznaka suda": " ",
                              "Naziv proizvoda": " ",
                              Lot: " ",
                              Zapremina: " ",
                              "Količina/Grupa repromaterijala": e.groupName,
                              "Boca/Repromaterijal": e.material,
                              "Rastur/Količina":
                                e.usedMaterialQuantity !== null
                                  ? e.usedMaterialQuantity
                                  : "-",
                            };

                            _this.json_data.push(obj);
                          });

                          rbr = rbr + 1;
                        });
                        this.isLoading = false;
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }, 10);
    },
    clear() {
      if (this.$refs.form !== undefined) this.$refs.form.reset();

      if (this.$refs.element1 !== undefined) this.$refs.element1.reset();

      this.filterEtiketa = "";
      this.fiterTipoviVina = "";
      this.fiterGodine = "";

      this.datumOdFiter = "";
      this.datumDoFiter = "";

      this.setDate();
    },
    changeSortKartica(column) {
      if (this.items_states.length > 0)
        if (typeof column !== "undefined")
          if (column !== "funkcije")
            if (this.paginationKartica.sortBy === column) {
              this.paginationKartica.descending =
                !this.paginationKartica.descending;
            } else {
              this.paginationKartica.sortBy = column;
              this.paginationKartica.descending = false;
            }
    },
    stampaj() {
      let _this = this;
      this.isLoading = true;

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = _this.naslov;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        if (
          _this.datumOdFiter !== "" ||
          _this.datumDoFiter !== "" ||
          _this.filterEtiketa !== "" ||
          _this.fiterGodine !== "" ||
          _this.fiterTipoviVina !== ""
        ) {
          let pomocni_tekst = "";

          if (_this.datumOdFiter !== "" || _this.datumDoFiter !== "") {
            if (_this.datumOdFiter !== "") {
              pomocni_tekst =
                pomocni_tekst +
                "Period: " +
                _this.formatDate1(_this.datumOdFiter) +
                ".";

              if (_this.datumDoFiter !== "")
                pomocni_tekst =
                  pomocni_tekst +
                  " - " +
                  _this.formatDate1(_this.datumDoFiter) +
                  ".";
            } else
              pomocni_tekst =
                pomocni_tekst +
                "Za period do: " +
                _this.formatDate1(_this.datumOdFiter) +
                ".";

            pomocni_tekst = pomocni_tekst + "<br>";
          }

          if (_this.fiterTipoviVina !== "") {
            pomocni_tekst =
              pomocni_tekst +
              "Tip vina: " +
              _this.fiterTipoviVina.substring(
                0,
                _this.fiterTipoviVina.length - 2
              );
            pomocni_tekst = pomocni_tekst + "<br>";
          }
          if (_this.fiterGodine !== "") {
            pomocni_tekst =
              pomocni_tekst +
              "Godina: " +
              _this.fiterGodine.substring(0, _this.fiterGodine.length - 2);
            pomocni_tekst = pomocni_tekst + "<br>";
          }
          if (_this.filterEtiketa !== "") {
            pomocni_tekst =
              pomocni_tekst +
              "Vino: " +
              _this.filterEtiketa.substring(0, _this.filterEtiketa.length - 2);
            pomocni_tekst = pomocni_tekst + "<br>";
          }

          var elementToPrint1 = document.createElement("p");

          elementToPrint1.innerHTML = pomocni_tekst + " <br>";

          elementToPrint1.style.margin = "5px 0px 0px 0px";
          elementToPrint1.style.fontSize = "14px";
          elementToPrint.append(elementToPrint1);
        }

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        jQuery.each(_this.json_fields, function (i, val) {
          var th = document.createElement("th"); //column
          var text = "";
          text = document.createTextNode(i);

          th.setAttribute("style", "padding-bottom: 4px;");

          th.appendChild(text);

          tr.appendChild(th);
        });

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        let poslednjiRed = null;

        jQuery.each(_this.json_data, function (i, val1) {
          var isLastElement = i == _this.json_data.length - 1;

          var row = document.createElement("tr");

          let pomJ = 0;

          jQuery.each(val1, function (i, val) {
            var cell = document.createElement("td");

            var cellText;

            if ((val === null || val === 0 || val === "") && !isLastElement)
              cellText = document.createTextNode("-");
            else cellText = document.createTextNode(val);

            cell.appendChild(cellText);

            if (i === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px; padding-bottom: 4px;"
              );
            else if (
              _this.json_fields_type[pomJ] === "Number" ||
              _this.json_fields_type[pomJ] === "StringRight"
            ) {
              cell.setAttribute(
                "style",
                "text-align :right; padding-bottom: 4px; padding-right: 5px;"
              );
            } else if (_this.json_fields_type[pomJ] === "Date") {
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
              );
            } else
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

            pomJ = pomJ + 1;

            row.appendChild(cell);
          });

          if (isLastElement) {
            poslednjiRed = row;
            // row.setAttribute("border", "none");
          }

          tblBody.appendChild(row);
        });

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "0px 0px 0px 0px";
        tbl.style.width = "100%";

        elementToPrint.appendChild(tbl);

        // var tbl = document.createElement("table");
        // var tblBody = document.createElement("tbody");

        // tbl.style.margin = "20px 0px 0px 82%";
        // tbl.style.width = "18%";
        // // tbl.setAttribute("border", "thin solid");
        // tbl.style.borderCollapse = "collapse";
        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // tblBody.appendChild(poslednjiRed);

        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "landscape" },
          // pagebreak: {
          //     mode: ['avoid-all', 'css', 'legacy']
          // }
          pagebreak: { avoid: ["tr", "td"], before: "#nextpage1" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            var totalPages = pdf.internal.getNumberOfPages();
            var i;

            for (i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);
              pdf.text(
                getDateTime(),
                0.9,
                pdf.internal.pageSize.getHeight() - 0.5
              );

              pdf.text(
                i + " od " + totalPages,
                pdf.internal.pageSize.getWidth() / 1.075,
                pdf.internal.pageSize.getHeight() - 0.5
              );
            }
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
  },
  mounted() {
    this.clear();

    if (this.wt_items.length === 0) {
      this.getAllWineTypes();
    }

    if (this.items_states.length === 0) this.getAllPracenjeEvidencije();
  },
};
</script>

<style scoped lang='scss'>
@import "./parts/../../assets/sass/parts/modalStyles_siri_modal";

div.layout.row.wrap {
  padding-top: 20px !important;
  max-height: 90px !important;
}

.topics tr {
  line-height: 14px;
}

.topics {
  margin-left: 42%;
  border-collapse: collapse;
  border-spacing: 0;
  width: 58%;
}

.topics th {
  height: 25px;
  font-weight: 500;
  font-size: 12px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.topics td {
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

.menuable__content__active {
  background-color: white;
}

@media print {
  table,
  div {
    break-inside: avoid;
  }
}

thead {
  display: table-header-group;
}
tfoot {
  display: table-row-group;
}
tr {
  page-break-after: always !important;
  page-break-before: always !important;
  page-break-inside: auto !important;
}

div {
  page-break-inside: avoid;
}
#nextpage1 {
  page-break-before: always;
}
</style>